import { MRT_ColumnDef, MRT_Row, MRT_RowData } from 'material-react-table';
import { useMemo, useState } from 'react';

import { EstadosSolicitudPeodidoEnum, MaterialTransferido, SolicitudesPedido } from '../interfaces';
import { EstadoComponente, } from '../components/ui';
import VisibilityIcon from '@mui/icons-material/Visibility';

import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from './auth';
import { cellNotFilter, formatDateWithTimeCell } from '../utils';
import { useCargarSeriesProductos } from '@/store/erp/productos/useCargarSeriesProductos.store';
import { Button } from '@mui/material';
import ModalObservacionGeneral from '../components/ui/ModalObservacionesGeneral';

import { IconButton, Tooltip } from '@mui/material';
import { Download } from '@mui/icons-material';



const colorEstado = (estado: EstadosSolicitudPeodidoEnum) => {
  switch (estado) {
    case EstadosSolicitudPeodidoEnum.ESPERA:
      return 'blue'
    case EstadosSolicitudPeodidoEnum.APROBADAS:
      return 'green'
    case EstadosSolicitudPeodidoEnum.RECHAZADO:
      return 'red'
    case EstadosSolicitudPeodidoEnum.ABIERTO:
      return 'orange'
    case EstadosSolicitudPeodidoEnum.FINALIZADO:
      return 'gray'
    default:
      return 'black'
  }
}
type useTableSolicitudesPedidoProps = {
  estado: string;
  onDownload?: (row: any, nameFile: string) => void;
}
type MRT_RowProps<T extends MRT_RowData> = {
  row: MRT_Row<T>;
}
export const useTableSolicitudesPedido = ({ estado, onDownload }: useTableSolicitudesPedidoProps) => {

  useCheckPermissions(PermissionsEnum.api_add_solicitudegreso);
  const handleCopiarLista = useCargarSeriesProductos(s => s.handleCopiarLista)
  const [details, setDetails] = useState<MaterialTransferido[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onDetails = (e: MRT_RowData) => {
    handleCopiarLista(e.productos)
    //console.log('test', e.productos)
    setDetails(JSON.parse(JSON.stringify((e.productos!))));
    setIsModalOpen(true);
  };

  
  /* const [details1, setDetails1] = useState<User[]>([])
  const [isModalOpen1, setIsModalOpen1] = useState(false);

  const onDetailsUser = (e: MRT_RowData) => {
    setDetails1(JSON.parse(JSON.stringify((e.user!))));
    setIsModalOpen1(true);
  } */

  const columns = useMemo<MRT_ColumnDef<SolicitudesPedido>[]>(() => [
    {
      ...cellNotFilter,
      accessorKey: 'url_pdf',
      header: "Reporte",
      size: 100,
      Cell: ({ row }) => (
      <Tooltip title="Descargar">
        <IconButton onClick={() => onDownload?.(row.original as any, `solicitud_${(row.original as any).numero_referencia}`)}>
          <Download color='secondary' />
        </IconButton>
      </Tooltip>
    )
    },
    
    {
      ...cellNotFilter,
      accessorKey: "detalles",
      header: "producto",
      size: 20,
      Cell: ({ row }) => {
        return (
          <>
            <Button
              variant='text'
              color="primary"
              onClick={() => {
                onDetails(row.original);
              }}
              startIcon={<VisibilityIcon />}
            >
              {'Ver'}
            </Button>

          </>
        );
      },
    },
    {
      accessorKey: "numero_referencia",
      header: "N° Referencia",
      size: 200,

    },
    {
      ...cellNotFilter,
      accessorKey: "user.username",
      header: "usuario",
      size: 100,

    },

    {
      ...cellNotFilter,
      accessorKey: "bodega_data.nombre",
      header: "bodega",
      size: 200,
    },
    ...(estado === EstadosSolicitudPeodidoEnum.ESPERA ?
      [
        {
          accessorKey: "observaciones.observacionSolicitudPedido",
          header: "observación del Solicitante",
          size: 200,
          Cell: ({ row }: MRT_RowProps<SolicitudesPedido>) => {
            return <ModalObservacionGeneral
              texto={
                row.original.observaciones?.observacionSolicitudPedido || 'N/A'
              }
              title='Observación'
            />
          }

        },

      ] : []),

    {
      accessorKey: "observaciones.observacionRevisionSolicitudPedido",
      header: 'observacion del Revisor',
      size: 200,
      Cell: ({ row }) => {
        return <ModalObservacionGeneral
          texto={
            row.original.observaciones?.observacionRevisionSolicitudPedido || 'N/A'
          }
          title="observación"
        />
      }
    },
    {
      ...cellNotFilter,
      accessorKey: "fecha_creacion",
      header: "Fecha de creacion",
      size: 200,
      Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_creacion')
    },
    {
      ...cellNotFilter,
      accessorKey: "estado_solicitud",
      header: "estado",
      size: 200,
      Cell: ({ row }) => (
        row.original.estado_solicitud != null ?
          <EstadoComponente
            backgroundColor={colorEstado(row.original.estado_solicitud as EstadosSolicitudPeodidoEnum)}
            texto={row.original.estado_solicitud || ''} /> : null
      ),
    },
  ], [])
  const columnsProductosDetallePedidosDb: MRT_ColumnDef<MaterialTransferido>[] = useMemo<
    MRT_ColumnDef<MaterialTransferido>[]
  >(
    () => [
      {
        accessorKey: 'codigo',
        header: 'Código',
        Cell: ({ row }) => row.original?.codigo || 'N/A',

      },
      {
        accessorKey: 'producto_data.descripcion',
        header: 'Descripción',
      },
      {
        accessorKey: 'producto_data.modelo_producto',
        header: 'Modelo',
        Cell: ({ row }) => row.original?.producto_data?.modelo_producto || 'N/A'
      },
      {
        accessorKey: 'producto_data.marca_producto',
        header: 'Marca',
        Cell: ({ row }) => row.original?.producto_data?.marca_producto || 'N/A'
      },
      {
        accessorKey: 'producto_data.categoria_producto',
        header: 'Categoria',
        Cell: ({ row }) => row.original?.producto_data?.categoria_producto || 'N/A'
      },
      {
        accessorKey: 'producto_data.unidad_medida',
        header: 'Medida',
        Cell: ({ row }) => row.original?.producto_data?.unidad_medida || 'N/A'
      },
      /* {
        accessorKey: 'cantidad_aprobada',
        header: 'cantidad A probada',
        Cell: ({ row }) => row.original?.cantidad_aprobada || 'N/A'
      },
      {
        accessorKey: 'cantidad',
        header: 'cant. Requerida'
      } */
    ],
    []
  );

  return {
    columns,
    columnsProductosDetallePedidosDb,
    isModalOpen,
    setIsModalOpen,
    details,
    setDetails,
    onDetails,
  }

}